module.exports = __webpack_public_path__ + "fonts/Helvetica.1b580d98.ttf";